import ROUTES from '../routers/helpersRouter/constantRouter'

// theme constant
export const gridSpacing = 3
export const gridSpacingForm = 2
export const drawerWidth = 260
export const drawerWidthMDClose = 80
export const appDrawerWidth = 320

export const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  basename: '/eLog',
  defaultPath: `${ROUTES.STATISTICAL}/${ROUTES.STATISTICAL_CHILD.REQUEST}`,
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 6
}

export const PERMISSION = {
  ADMIN: 'ADMIN',
  GD: 'GD',
  TP_KINH_DOANH: 'TP_KINH_DOANH',
  SALE: 'SALE',
  TP_KE_HOACH: 'TP_KE_HOACH',
  OP: 'OP',
  PRICING: 'PRICING',
  CUSTOMER_SERVICES: 'CUSTOMER_SERVICES',
  COORDINATION: 'COORDINATION',
  CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
  DRIVE: 'DRIVE',
  TP_KE_TOAN: 'TP_KE_TOAN',
  KE_TOAN_QUY: 'KE_TOAN_QUY',
  KE_TOAN_CONG_NO: 'KE_TOAN_CONG_NO',
  KE_TOAN_TONG_HOP: 'KE_TOAN_TONG_HOP'
}
